var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96875 0.765625C1.36914 0.765625 0.125 2.0542 0.125 3.60938V17.8281C0.125 19.4277 1.36914 20.6719 2.96875 20.6719H20.0312C21.5864 20.6719 22.875 19.4277 22.875 17.8281V7.875C22.875 6.31982 21.5864 5.03125 20.0312 5.03125H3.67969C3.27979 5.03125 2.96875 4.72021 2.96875 4.32031C2.96875 3.96484 3.27979 3.60938 3.67969 3.60938H20.0312C20.7866 3.60938 21.4531 2.9873 21.4531 2.1875C21.4531 1.43213 20.7866 0.765625 20.0312 0.765625H2.96875ZM18.6094 11.4297C19.3647 11.4297 20.0312 12.0962 20.0312 12.8516C20.0312 13.6514 19.3647 14.2734 18.6094 14.2734C17.8096 14.2734 17.1875 13.6514 17.1875 12.8516C17.1875 12.0962 17.8096 11.4297 18.6094 11.4297Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCredit);
export default __webpack_public_path__ + "static/media/AccountCredit.730b850a05c7d6d14fa510e4c5b78506.svg";
export { ForwardRef as ReactComponent };